import React from 'react';

const Difference = () => {
  const differences = [
    { title: 'Data-Driven Approach', desc: 'We rely on analytics, not guesswork, to drive your campaigns forward.', icon: '📊' },
    { title: 'Transparent Reporting', desc: 'Full visibility into your campaign performance with real-time dashboards.', icon: '📈' },
    { title: 'Dedicated Experts', desc: 'A team of seasoned professionals dedicated to your success.', icon: '👥' },
    { title: 'Agile Methodology', desc: 'We adapt quickly to market changes to keep you ahead of the curve.', icon: '⚡' },
    { title: 'Custom Strategies', desc: 'No cookie-cutter solutions. We tailor every plan to your unique needs.', icon: '🎯' },
    { title: 'Proven ROI', desc: 'Our focus is always on maximizing your return on investment.', icon: '💰' }
  ];

  return (
    <section id="difference" className="difference-section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">
            The BuzzMinded <span className="text-gradient-teal-gold">Difference</span>
          </h2>
        </div>

        <div className="difference-grid">
          {differences.map((diff, index) => (
            <div key={index} className="difference-card">
              <div className="diff-icon">{diff.icon}</div>
              <h3 className="diff-title">{diff.title}</h3>
              <p className="diff-desc">{diff.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Difference;
